import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface SheppardBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

/**
 * The supplied artwork is a 150 square whose mark fills ~93% of the box, where
 * the other brand marks fill ~71% of theirs. The padded viewBox keeps the mark
 * centred on (75, 75) while scaling it to match.
 */
function SheppardBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="-22.67 -22.67 195.33 195.33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sheppard</title>
      <path
        d="m135.15201,104.93977c-13.20209,-16.04054 -36.56978,-22.93863 -36.6688,-22.93863c2.80544,-9.76955 5.90793,-28.87957 -3.66358,-49.37581c-13.99421,-30.03475 -29.96874,-21.65142 -39.96932,0.19803c0,0 -11.78286,23.3677 -3.43254,49.11177l0,0.09902s0,0 0,0c-2.57441,0.79213 -24.15982,7.78923 -36.56978,22.93863c-13.23509,16.07354 -8.28431,23.96179 -8.28431,23.96179c0,0 3.1685,7.92125 22.31153,7.92125c0,0 23.73075,0.99016 46.07529,-19.40707l0,0c22.37754,20.33122 46.1743,19.40707 46.1743,19.40707c19.14303,0 22.31153,-7.88825 22.31153,-7.88825c0,0 4.95078,-7.92125 -8.28431,-23.9948l0,-0.03301zm-75.68097,-56.96701c4.48871,-12.31095 10.1326,-18.51593 15.34743,-18.51593c6.17198,0 10.62768,6.27099 15.34743,18.51593c3.59757,9.37348 3.53156,21.05733 0.23104,32.2461c-0.69311,-0.16503 -13.96121,-3.1685 -31.18993,0l0,-0.06601s-4.35669,-19.5721 0.23104,-32.14709l0.03301,-0.03301zm-22.31153,77.99134s-28.38449,3.00348 -16.33758,-13.8952c12.24494,-17.19572 30.56283,-22.83961 32.90621,-23.49972l0.09902,0.19803c4.65374,9.37348 10.00058,16.93168 15.51245,23.00464c-15.97453,13.23509 -32.2131,14.19224 -32.2131,14.19224l0.03301,0zm37.75797,-19.6051c-4.91778,-5.11581 -9.63752,-11.55183 -13.59815,-19.67111c6.40301,-1.18819 16.27157,-2.24436 26.96527,-0.29705c-3.03648,7.49219 -7.52519,14.45629 -13.3011,20.06717l0,-0.09902l-0.06601,0zm37.923,19.6051s-16.20556,-1.05617 -32.18009,-14.29126c5.51187,-6.07296 10.79271,-13.59815 15.44644,-22.93863c0.29705,0.06601 20.10018,5.01679 33.10424,23.30169c12.04691,16.89867 -16.33758,13.8952 -16.33758,13.8952l-0.03301,0.03301z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconSheppardBrand(props: SheppardBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <SheppardBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
